import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import AuthForm from 'components/AuthForm/AuthForm';
import RegisterForm from 'components/RegisterForm/RegisterForm';
import { Button } from 'components';
import './AuthModal.scss';
import { width } from '@mui/system';

export default function AuthModal({ open, onClose }) {
  // allow external trigger via window event
  useEffect(() => {
    const handler = () => onClose && onClose(false) === undefined ? null : null
  }, [])
  const [mode, setMode] = useState('login');
  if (!open) return null;

  const modalContent = (
    <div className="auth-modal-overlay" onClick={onClose}>
      <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
        <div className="auth-modal-header">
          <div>
            <Button className="btn_modal_close" onClick={() => setMode('login')}  disabled={mode === 'login'}>Вход</Button>
            <Button className="btn_modal_close" onClick={() => setMode('register')} disabled={mode === 'register'} style={{ marginLeft: 8 }}>Регистрация</Button>
          </div>
          <Button className="btn_modal_close" onClick={onClose}>×</Button>
        </div>
        {mode === 'login' ? <AuthForm onSuccess={onClose} /> : <RegisterForm onSuccess={onClose} />}
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}
